import { useQuery } from '@tanstack/react-query'
import restApi from 'apis/restApi'
import { useMemo } from 'react'
import { fetchToken } from 'utils/authUtils'
import { showAvailable } from 'utils/commonUtils'
import { selectObject } from 'utils/formUtils'

export const useContractLocations = (selectedId) => {
  const result = useQuery({
    queryKey: ['contractLocations'],
    queryFn: async () =>
      await restApi.get('/contracts/location', {
        headers: { Authorization: `Bearer ${fetchToken()}` },
      }),
  })

  const options = useMemo(
    () =>
      result.data?.data
        ? selectObject(
            showAvailable(result.data?.data),
            Number.parseInt(selectedId) || null,
            false,
            'All Locations'
          )
        : [],
    [result.data?.data, selectedId]
  )

  return { ...result, options, data: result.data?.data }
}
